import { TranslationService } from '../../../react/services/translation.service';
import { AnalyticsService } from '../../../typescript/common/analytics-service';
import Utils from '../../../typescript/common/utils';
import { MunicipalitySelectorModalHelper } from '../../municipality-selector-modal/municipality-selector-modal.helper';
import './menu-mobile.scss';

(function menuMobile() {
  const pageNavigationMobiles: NodeListOf<HTMLElement> = document.querySelectorAll('[data-component="menu-mobile-component"]');
  if (pageNavigationMobiles && pageNavigationMobiles.length > 0) {
    class MenuMobile {
      public translationExpand: string;
      public translationCollapse: string;

      public hasPriorOverlay: boolean;

      constructor() {
        this.translationExpand = TranslationService.get('common.expand');
        this.translationCollapse = TranslationService.get('common.collapse');
        this.hasPriorOverlay = false;
      }

      public init() {
        pageNavigationMobiles.forEach((element) => {
          element.addEventListener('hide-mobile-navigation', () => {
            this.hideMobileNavigation(null, element);
          });

          element.hidden = true;
          const button: HTMLElement | null = document.querySelector('[data-component="mobile-menu-button"]');
          button?.addEventListener('click', () => {
            if (element.classList.contains('show')) {
              this.hideMobileNavigation(button, element);
              AnalyticsService.addEvent(AnalyticsService.MobileMenu, 'Öppna/stäng mobilmeny', 'Stäng');
            } else {
              this.showMobileNavigation(button, element);
              AnalyticsService.addEvent(AnalyticsService.MobileMenu, 'Öppna/stäng mobilmeny', 'Öppna');
            }
          });

          const allFirstLevels: NodeListOf<HTMLElement> = document.querySelectorAll('.menu-mobile__first-level');

          const collapseButtons: NodeListOf<HTMLElement> = document.querySelectorAll('[data-first-level-toggle]');
          collapseButtons.forEach((collapseButton) => {
            collapseButton.setAttribute('aria-label', this.translationExpand);
            collapseButton.addEventListener('click', () => {
              const parentElement = Utils.findClosest(collapseButton, 'menu-mobile__first-level');
              const bothToggleButtons = collapseButton.parentElement?.querySelectorAll('[data-first-level-toggle]');
              if (!collapseButton.classList.contains('collapsed')) {
                bothToggleButtons?.forEach((toggleButton) => {
                  toggleButton.setAttribute('aria-label', this.translationCollapse);
                });
                allFirstLevels.forEach((firstLevel) => {
                  firstLevel.classList.add('menu-mobile__first-level--neutral');
                });
                parentElement?.classList?.remove('menu-mobile__first-level--neutral');
              } else {
                bothToggleButtons?.forEach((toggleButton) => {
                  toggleButton.setAttribute('aria-label', this.translationExpand);
                });
                parentElement?.classList.add('menu-mobile__first-level--neutral');
              }
            });
          });

          const muncipalityButton: HTMLElement | null = document.querySelector('[data-component="municipality-mobile-menu-button"]');
          muncipalityButton?.addEventListener('click', () => {
            this.hideMobileNavigation(null, element);
            MunicipalitySelectorModalHelper.openMunicipalitySelectorModal();
          });
        });
        this.setUpAnalyticsEventForMobileMenuLinks();
      }

      private showMobileNavigation(button: HTMLElement, element: HTMLElement) {
        element.hidden = false;
        setTimeout(() => {
          element.classList.add('show');
          button.setAttribute('aria-expanded', 'true');
          button.classList.remove('collapsed');

          const mobileMenuButtonText = document.querySelector('[data-component="mobile-menu-button-text"]');
          const mobileMenuButtonCloseText = document.querySelector('[data-component="mobile-menu-button-close-text"]');

          if (mobileMenuButtonText && mobileMenuButtonCloseText) {
            mobileMenuButtonText.classList.add('d-none');
            mobileMenuButtonCloseText.classList.remove('d-none');
          }

          const mobileMenuButtonImage = document.querySelector('[data-component="mobile-menu-button-image"]');
          const mobileMenuButtonCloseImage = document.querySelector('[data-component="mobile-menu-button-close-image"]');

          if (mobileMenuButtonImage && mobileMenuButtonCloseImage) {
            mobileMenuButtonImage.classList.add('d-none');
            mobileMenuButtonCloseImage.classList.remove('d-none');
          }

          const collapseSiteSearchEvent = new Event('collapse-hide');
          const siteSearch = document.querySelector('[data-component="site-search"]');
          if (siteSearch) {
            siteSearch.dispatchEvent(collapseSiteSearchEvent);
          }

          // NV-4953 Has body class has-overlay-sm (next departure is open)
          this.hasPriorOverlay = document.body.classList.contains('has-overlay-sm');
          if (!this.hasPriorOverlay) document.body.classList.add('has-overlay-sm');

          this.setUpFocusTrap(element, true);
        }, 100);
      }

      private hideMobileNavigation(button: Element | null, element: HTMLElement) {
        this.setUpFocusTrap(element, false);
        if (element.hidden) {
          return;
        }

        if (!button) {
          element = document.querySelector('[data-component="mobile-menu-button"]') as HTMLElement;
          if (element) button = element;
        }

        if (!this.hasPriorOverlay) document.body.classList.remove('has-overlay-sm');

        element.classList.remove('show');
        button?.setAttribute('aria-expanded', 'false');
        button?.classList.add('collapsed');

        const mobileMenuButtonText = document.querySelector('[data-component="mobile-menu-button-text"]');
        const mobileMenuButtonCloseText = document.querySelector('[data-component="mobile-menu-button-close-text"]');

        if (mobileMenuButtonText && mobileMenuButtonCloseText) {
          mobileMenuButtonText.classList.remove('d-none');
          mobileMenuButtonCloseText.classList.add('d-none');
        }

        const mobileMenuButtonImage = document.querySelector('[data-component="mobile-menu-button-image"]');
        const mobileMenuButtonCloseImage = document.querySelector('[data-component="mobile-menu-button-close-image"]');

        if (mobileMenuButtonImage && mobileMenuButtonCloseImage) {
          mobileMenuButtonImage.classList.remove('d-none');
          mobileMenuButtonCloseImage.classList.add('d-none');
        }

        setTimeout(() => {
          element.hidden = true;
        }, 350);
      }

      private setUpAnalyticsEventForMobileMenuLinks() {
        const mobileNavigationLinks = document.getElementById('menu-mobile')?.getElementsByTagName('a');
        if (!mobileNavigationLinks) {
          return;
        }
        for (let i = 0; i < mobileNavigationLinks.length; i += 1) {
          mobileNavigationLinks?.[i].addEventListener('click', () => {
            AnalyticsService.addEvent(AnalyticsService.MobileMenu, 'Klick på menyalternativ', mobileNavigationLinks[i].innerText);
          });
        }
      }

      private setUpFocusTrap(element: HTMLElement, addListener: boolean) {
        const toggleMenuButton = document.getElementById('mobile-menu-button');

        const localElements: NodeListOf<HTMLElement> = element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const focusableElements: Array<HTMLElement> = Array.prototype.slice.call(localElements);
        if (toggleMenuButton) focusableElements.unshift(toggleMenuButton);

        if (addListener) {
          element.addEventListener('keydown', this.focusTrapListener);
          toggleMenuButton?.addEventListener('keydown', this.focusTrapListener);
        } else {
          element.removeEventListener('keydown', this.focusTrapListener);
          toggleMenuButton?.removeEventListener('keydown', this.focusTrapListener);
        }
      }

      private focusTrapListener(e: KeyboardEvent) {
        if (e.key !== 'Tab') {
          return;
        }

        const toggleMenuButton = document.getElementById('mobile-menu-button');
        if (pageNavigationMobiles.length > 0) {
          const localElements: NodeListOf<HTMLElement> = pageNavigationMobiles[0].querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const focusableElements: Array<HTMLElement> = Array.prototype.slice.call(localElements);
          if (toggleMenuButton) focusableElements.unshift(toggleMenuButton);

          if (e.shiftKey) {
            if (document.activeElement === focusableElements[0]) {
              focusableElements[focusableElements.length - 1].focus();
              e.preventDefault();
            }
          } else if (document.activeElement === focusableElements[focusableElements.length - 1]) {
            focusableElements[0].focus();
            e.preventDefault();
          }
        }
      }
    }
    const component = new MenuMobile();
    component.init();
  }
})();

